import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";
import { map } from "lodash";
import Pagination from "react-paginate";
import TextFields from "../UI/TextFiled";
import SwitchToggle from "../UI/SwitchToggle";
import {
  downloadUsers,
  getSearchUsers,
  getUsers,
  updateUser
} from "../../store/actions/user";

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      currentPage: 1,
      usersLength: 0
    };
    this.onSearch = this.onSearch.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.onDownload = this.onDownload.bind(this);
  }
  async componentDidMount() {
    await this.props.getUsers(this.props.auth.token, 1);
    let usersShow = [];
    map(this.props.users.results, data => usersShow.push(data));
    if (this.state.usersLength <= usersShow.length) {
      this.setState({ usersLength: usersShow.length });
    }
  }
  handleInput(e) {
    this.setState({ searchValue: e.target.value });
  }
  async handleToggle(id, active, e) {
    const data = { is_active: !active };
    await this.props.updateUser(id, data, this.props.auth.token);
    this.props.getUsers(this.props.auth.token, this.state.currentPage);
  }
  async handleClick(pagenumber) {
    await this.setState({ currentPage: pagenumber.selected + 1 });
    this.props.getUsers(this.props.auth.token, this.state.currentPage);
  }
  onSearch() {
    this.props.getSearchUsers(this.props.auth.token, this.state.searchValue);
  }
  async onDownload() {
    const response = await this.props.downloadUsers(
      this.props.auth.token,
      this.state.searchValue
    );
    const url = window.URL.createObjectURL(new Blob([response.payload]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Drivers.csv");
    link.click();
  }
  render() {
    const users = map(this.props.users.results, data => data);
    let currentUsersCount =
      this.state.usersLength > 0 ? this.state.usersLength : users.length;
    let pageCount = Math.ceil(this.props.users.count / currentUsersCount);

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">User Management</h1>
              </div>
              <div className="col-xs-3">
                <Form onSubmit={this.submitted}>
                  {formApi => (
                    <form
                      onSubmit={formApi.submitForm}
                      className="search"
                      onChange={this.handleInput}
                    >
                      <TextFields
                        type="text"
                        hintText="Search"
                        value={this.state.searchValue}
                      />
                      <button
                        className="no-style search-btn pointer"
                        onClick={this.onSearch}
                      >
                        <i className="fa fa-search" />
                      </button>
                    </form>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <div className="table withHover mt-20">
            <table>
              <thead>
                <tr>
                  <th>User ID</th>
                  <th>User Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>User Status</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td
                      onClick={() =>
                        this.props.history.push(
                          `/user-relationship/users/${user.id}`
                        )
                      }
                    >
                      {user.id}
                    </td>
                    <td
                      onClick={() =>
                        this.props.history.push(
                          `/user-relationship/users/${user.id}`
                        )
                      }
                    >
                      {user.first_name}
                    </td>
                    <td
                      onClick={() =>
                        this.props.history.push(
                          `/user-relationship/users/${user.id}`
                        )
                      }
                    >
                      {user.mobile_number}
                    </td>
                    <td
                      onClick={() =>
                        this.props.history.push(
                          `/user-relationship/users/${user.id}`
                        )
                      }
                    >
                      {user.email}
                    </td>
                    <td
                      onClick={() => this.handleToggle(user.id, user.is_active)}
                    >
                      <SwitchToggle
                        notForm
                        toggled={user.is_active}
                        field="is_active"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="text-right mt-20" onClick={this.onDownload}>
            <Link to="#" className="flex-align-y font-sm w-800">
              <i className="fa fa-download mr-10" />
              Download Excel File
            </Link>
          </div>
          {pageCount > 1 && (
            <Pagination
              onPageChange={this.handleClick}
              pageCount={pageCount}
              initialPage={0}
              breakClassName={"break-me"}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users,
    auth: state.auth
  };
}

export default connect(
  mapStateToProps,
  { getUsers, getSearchUsers, updateUser, downloadUsers }
)(UserManagement);



// WEBPACK FOOTER //
// ./src/components/User-relationship/UserManagement.js